import { inject, Injectable, signal, WritableSignal } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { finalize, Observable, tap } from 'rxjs';
import Keycloak from 'keycloak-js';

import { environment } from '../../../environments/environment';
import { NotificationService } from './notification.service';
import { Permission, User } from '../models/user';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  private readonly keycloak = inject(Keycloak);
  private readonly http = inject(HttpClient);
  private readonly notificationService = inject(NotificationService);

  user: WritableSignal<User | null> = signal(null);

  logout(): void {
    this.keycloak.logout();
  }

  getUser(): Observable<User> {
    this.notificationService.showModalSpinner();
    return this.http.get<User>(`${environment.api.user}/user-info`).pipe(
      tap((response: User) => {
        this.user.set(response);
      }),
      finalize(() => this.notificationService.hideModalSpinner())
    );
  }

  getKeycloakId(): string {
    return this.keycloak.idTokenParsed?.sub ?? '';
  }

  isAuthorized(restrictedPermission: Array<Permission> | Permission): boolean {
    if (!Array.isArray(restrictedPermission)) restrictedPermission = [restrictedPermission];

    return restrictedPermission.some((permission: Permission) => (this.user() as User).permissions.includes(permission));
  }

}
